import UseCase, { NoParams } from "../../core/useCase/UseCase";
import { SessionRepository } from "../repository/SessionRepository";

/** Milliseconds since the last recorded real user input, across all tabs. */
export default class GetSessionIdleMilliseconds extends UseCase<
  number,
  NoParams
> {
  repository: SessionRepository;

  constructor(repository: SessionRepository) {
    super();
    this.repository = repository;
  }

  execute = () => this.repository.getIdleMilliseconds();
}
